import React from 'react';
import cx from 'classnames';
import { SLDSTextarea } from '@salesforce/design-system-react';

function Textarea({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSTextarea, Object.assign({}, props, {
    className: cx(className, "tds-textarea")
  }));
}
Textarea.displayName = "Textarea";
Textarea.propTypes = SLDSTextarea.propTypes;
Textarea.defaultProps = SLDSTextarea.defaultProps;

export { Textarea as default };
